<template>
  <div id="shows-list" v-if="showsList">
    <div class="row align-center medium-collapse">
      <div class="xxlarge-10 medium-12 columns">
        <div class="show-list-item" v-for="show in showsList">
          <h2 :class="['date-' + show.date]">{{show.date}}</h2>
          <ul>
            <li v-for="entrie in show.posts" v-on:mouseenter="mouseEnter" v-on:mouseleave="mouseLeave" v-parallax="0.02">
              <img :data-url="entrie.exposicao_main_image.sizes['product-thumb-retina']" v-bind:alt="entrie.exposicao_title" v-lazyload>
              <router-link :to="`/exposicao/${entrie.exposicao_slug}`">{{entrie.exposicao_title}}<span v-if="entrie.exposicao_main_author">{{entrie.exposicao_main_author}}</span> </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TweenMax } from 'greensock';

export default {
  name: 'shows-list',
  data () {
    return {
      loading: false
    }
  },
  methods: {
    mouseLeave: function(event) {
      TweenMax.to(event.target, 1, {
        scale: 1,
        transformOrigin: "center",
        ease: Expo.easeOut
      })
      TweenMax.set(event.target.querySelector('img'), {
        autoAlpha: 0,
        //scaleY: 1
      })
    },
    mouseEnter: function(event){
      TweenMax.to(event.target, 1, {
        scale: 1.05,
        transformOrigin: "center",
        ease: Expo.easeOut
      })

      TweenMax.fromTo(event.target.querySelector('img'), 1, {
        autoAlpha: 0,
        //scaleY: 1.1
      }, {
        autoAlpha: 1,
        //scaleY: 1,
        ease: Expo.easeOut
      })
    }
  },
  mounted () {
  },
  computed: {
   showsList() {
    return this.$store.getters.getShows;
   }
 }
}
</script>
<!-- styling for the component -->
<style lang="scss">

#shows-list {
  margin: 160px 0;

  h2 {
    font-family: 'Libre Baskerville';
    @include responsive-font-size(55px);
    line-height: 1;
    color: rgba(0,0,0,.3);
    margin-bottom: 30px;
  }

  .show-list-item {
    margin-bottom: 125px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  ul {
    li {
      display: table;
      position: relative;
      margin-bottom: 20px;

      a {
        font-family: 'Libre Baskerville';
        @include responsive-font-size(45px);
        letter-spacing: -0.7px;
        line-height: 1.35em;
        text-transform: initial;

        span {
          position: relative;
          color: rgba(0,0,0,.4);
          display: inline-block;
          font-size: .5em;
          letter-spacing: -0.25px;
          line-height: 1.5;
          margin-left: 10px;
        }
      }

      img {
        position: absolute;
        opacity: 0;
        visibility: hidden;
        top: 0;
        left: 50%;
        height: 200px;
        max-width: 100%;
        pointer-events: none;

        -webkit-transform: translate3d(-50%, -50%, 0);
                transform: translate3d(-50%, -50%, 0);
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

@include max-screen($medium) {
  #shows-list {
    padding: 0 60px;
  }
}

@include max-screen($small) {
  #shows-list {
    padding: 0 30px;
    margin: 100px 0;

    ul {
      li {
        a {
          span {
            display: block;
            margin-left: 0;
          }
        }
      }
    }
  }
}

@include max-screen($xsmall) {
  #shows-list {
    padding: 0 20px;
    margin: 100px 0 80px;

    .show-list-item {
      margin-bottom: 85px;
    }

    h2 {
      margin-bottom: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/blocks/showsList.vue